import { render, staticRenderFns } from "./CreateVideoModal.vue?vue&type=template&id=34beb685&"
import script from "./CreateVideoModal.vue?vue&type=script&lang=ts&"
export * from "./CreateVideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateVideoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3194833414/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34beb685')) {
      api.createRecord('34beb685', component.options)
    } else {
      api.reload('34beb685', component.options)
    }
    module.hot.accept("./CreateVideoModal.vue?vue&type=template&id=34beb685&", function () {
      api.rerender('34beb685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreateVideoModal.vue"
export default component.exports